export default __webpack_public_path__ + "static/media/hourglass_dove.760fec72.svg";